import React from 'react';
import { FundChildrenData, FundChildrenDataLabel, FundChildrenItems } from './style';
import { Radio } from '../Radio';
import { DeleteIcon } from './icons';

const RenderColumnLabels = ({
  table,
  style,
  isStructured,
  error,
  onEnableValue,
  activeFundChildValue,
  fundId,
  onClearValuesColumn,
  bgColor,
  disabled
}) => {
  return (
    <FundChildrenItems style={style} isMultipleItems={table.columns?.length > 2} isHeader={true}>
      {table.columns?.map(value => {
        return (
          <FundChildrenData
            bgColor={bgColor}
            isMultipleItems={table.columns?.length > 2}
            key={value.id}
          >
            <FundChildrenDataLabel>
              <div className="label">
                {!isStructured && !disabled && (
                  <Radio
                    id={`grid-table-sidebar-column-radio-${table.id}-${value.id}`}
                    className="radio_btn"
                    onClick={() => onEnableValue(table.id, value)}
                    isChecked={
                      value.id === activeFundChildValue?.id &&
                      activeFundChildValue?.foundChildId === table.id
                    }
                  />
                )}
                <p title={value.description}>{value.name}</p>
              </div>
              {!disabled && (
                <span
                  id={`grid-table-sidebar-column-clear-${table.id}-${value.id}`}
                  onClick={() => onClearValuesColumn(fundId, table.id, value.id)}
                  className="delete_btn"
                >
                  <DeleteIcon />
                </span>
              )}
            </FundChildrenDataLabel>
          </FundChildrenData>
        );
      })}
    </FundChildrenItems>
  );
};

export default React.memo(RenderColumnLabels);
